import { ChartsSection } from "./ChartsSection";
import { InputSection } from "./InputSection";
import "./IPR.css";
import { ResultsSection } from "./ResultsSection";
import { NotesSection } from "./NotesSection";


const IPRCalculator: React.FC = () => {
	const handlePaste = () => { };

	return (
		<div className="ipr__container" onPasteCapture={handlePaste} tabIndex={0}>
			<InputSection />
			<ResultsSection />
			<div className="ipr__notes-charts round-corner-container">
				<ChartsSection />
				<NotesSection />
			</div>
		</div >
	)
}

export default IPRCalculator;
